import { render } from "./tax.vue?vue&type=template&id=151d93c8&scoped=true"
import script from "./tax.vue?vue&type=script&lang=js"
export * from "./tax.vue?vue&type=script&lang=js"

import "./tax.vue?vue&type=style&index=0&id=151d93c8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151d93c8"]])

export default __exports__